module.exports = __webpack_public_path__ + "img/dirty_sink.f3c0ee02.svg";